// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextArea Component Styles */

.scl--web-component-textarea-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  padding-bottom: 20px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  caret-color: transparent;
  position: relative;
}

.scl--web-component-textarea-input-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  min-height: 189px;
  border: 1px solid #7D8187;
  border-radius: 2px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  transition: border-color 0.3s ease;
  position: relative;
  cursor: text;
}

.scl--web-component-textarea-input-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  background: var(--scl-input-field-select, #84A578);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scl--web-component-textarea-input-plate:focus-within::after {
  opacity: 1;
}

.scl--web-component-textarea-input-plate:hover:not(:focus-within) {
  border-color: #9EA0A4;
}

.scl--web-component-textarea-input-plate:focus-within {
  border-color: #9EA0A4;
}

.scl--web-component-textarea-input-plate.warning::after {
  background: #FFC18E;
  opacity: 1;
}

.scl--web-component-textarea-input-plate.error::after {
  background: #F8868A;
  opacity: 1;
}

.scl--web-component-textarea-input-plate.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.scl--web-component-textarea-input-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 13px 0px 20px;
  gap: 12px;
  width: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  box-sizing: border-box;
}

.scl--web-component-textarea-value-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 14px 0px 16px;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
}

.scl--web-component-textarea-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px;
  width: 100%;
  height: 100%;
  flex: 1;
  order: 0;
  flex-grow: 1;
  position: relative;
}

.scl--web-component-textarea-input {
  width: 100%;
  min-height: 120px;
  font-family: var(--primary-font);
  font-style: light;
  font-weight: 274;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #FFFFFF;
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin: 0;
  resize: none;
  overflow: hidden;
  flex: 1;
  order: 1;
  flex-grow: 1;
  caret-color: transparent !important;
  box-sizing: border-box;
}

.scl--web-component-textarea-input:focus {
  caret-color: #FFFFFF !important;
}

.scl--web-component-textarea-input:disabled {
  cursor: not-allowed;
}

/* Disable autofill styles */
.scl--web-component-textarea-input:-webkit-autofill,
.scl--web-component-textarea-input:-webkit-autofill:hover,
.scl--web-component-textarea-input:-webkit-autofill:focus,
.scl--web-component-textarea-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #0A0A0A inset !important;
  -webkit-text-fill-color: #FFFFFF !important;
  transition: background-color 5000s ease-in-out 0s;
}

/* Footer wrapper for assistive text and character count */
.scl--web-component-textarea-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.scl--web-component-textarea-assistive {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 4px 2px 14px;
  height: 16px;
  flex: 1;
  order: 0;
  flex-grow: 0;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: rgba(255, 255, 255, 0.54);
}

.scl--web-component-textarea-assistive.error {
  color: #FF5252;
}

/* Character Count Styles */
.scl--web-component-textarea-character-count {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 14px 2px 4px;
  height: 16px;
  flex: none;
  order: 1;
  flex-grow: 0;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: rgba(255, 255, 255, 0.54);
  white-space: nowrap;
}

/* ✅ Floating Label Styles - Always visible, animates position */
.scl--web-component-textarea-label {
  position: absolute;
  left: 21px;
  top: 24px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #7D8187;
  background: transparent;
  padding: 0 4px;
  margin: 0 -4px;
  pointer-events: none;
  transition: all 0.3s ease;
  z-index: 1;
  opacity: 1;
}

/* ✅ Floating state - label moves to top */
.scl--web-component-textarea-label.floating {
  top: 0;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 16px;
  background: #0A0A0A;
  color: #7D8187;
  padding: 0 6px;
  margin: 0 -6px;
}

.scl--web-component-textarea-input-plate:focus-within .scl--web-component-textarea-label {
  top: 0;
  transform: translateY(-50%);
  font-size: 14px;
  line-height: 16px;
  background: #0A0A0A;
  color: #7D8187;
  padding: 0 6px;
  margin: 0 -6px;
}

/* ✅ Hover effect on label */
.scl--web-component-textarea-input-plate:hover:not(:focus-within) .scl--web-component-textarea-label {
  color: #C9CACD;
}

.scl--web-component-textarea-input-plate:hover:not(:focus-within) .scl--web-component-textarea-label .scl--web-component-textarea-required-asterisk {
  color: #EB5252;
}

/* Clear Button Styles */
.scl--web-component-textarea-clear-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  margin: 14px 0 0 0;
  background: transparent;
  border: none;
  cursor: pointer;
  flex: none;
  order: 1;
  flex-grow: 0;
  color: #7D8187;
  align-self: flex-start;
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease;
  pointer-events: auto;
}

.scl--web-component-textarea-clear-button:hover {
  color: #FFFFFF;
}

.scl--web-component-textarea-clear-button.hidden {
  opacity: 0;
  transform: scale(0.8);
  pointer-events: none;
}

/* Required Asterisk Styles */
.scl--web-component-textarea-required-asterisk {
  color: #EB5252;
}

/* Custom scrollbar for textarea */
.scl--web-component-textarea-input::-webkit-scrollbar {
  width: 6px;
}

.scl--web-component-textarea-input::-webkit-scrollbar-track {
  background: rgba(125, 129, 135, 0.1);
}

.scl--web-component-textarea-input::-webkit-scrollbar-thumb {
  background: #7D8187;
  border-radius: 3px;
}

.scl--web-component-textarea-input::-webkit-scrollbar-thumb:hover {
  background: #FFFFFF;
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/input/textarea/css/textArea.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kDAAkD;EAClD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* TextArea Component Styles */\n\n.scl--web-component-textarea-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  padding-bottom: 20px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  caret-color: transparent;\n  position: relative;\n}\n\n.scl--web-component-textarea-input-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  min-height: 189px;\n  border: 1px solid #7D8187;\n  border-radius: 2px;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  transition: border-color 0.3s ease;\n  position: relative;\n  cursor: text;\n}\n\n.scl--web-component-textarea-input-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  background: var(--scl-input-field-select, #84A578);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.scl--web-component-textarea-input-plate:focus-within::after {\n  opacity: 1;\n}\n\n.scl--web-component-textarea-input-plate:hover:not(:focus-within) {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-textarea-input-plate:focus-within {\n  border-color: #9EA0A4;\n}\n\n.scl--web-component-textarea-input-plate.warning::after {\n  background: #FFC18E;\n  opacity: 1;\n}\n\n.scl--web-component-textarea-input-plate.error::after {\n  background: #F8868A;\n  opacity: 1;\n}\n\n.scl--web-component-textarea-input-plate.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.scl--web-component-textarea-input-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0px 13px 0px 20px;\n  gap: 12px;\n  width: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  box-sizing: border-box;\n}\n\n.scl--web-component-textarea-value-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 14px 0px 16px;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n}\n\n.scl--web-component-textarea-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding: 0px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  position: relative;\n}\n\n.scl--web-component-textarea-input {\n  width: 100%;\n  min-height: 120px;\n  font-family: var(--primary-font);\n  font-style: light;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: 0.25px;\n  color: #FFFFFF;\n  background: transparent;\n  border: none;\n  outline: none;\n  padding: 0;\n  margin: 0;\n  resize: none;\n  overflow: hidden;\n  flex: 1;\n  order: 1;\n  flex-grow: 1;\n  caret-color: transparent !important;\n  box-sizing: border-box;\n}\n\n.scl--web-component-textarea-input:focus {\n  caret-color: #FFFFFF !important;\n}\n\n.scl--web-component-textarea-input:disabled {\n  cursor: not-allowed;\n}\n\n/* Disable autofill styles */\n.scl--web-component-textarea-input:-webkit-autofill,\n.scl--web-component-textarea-input:-webkit-autofill:hover,\n.scl--web-component-textarea-input:-webkit-autofill:focus,\n.scl--web-component-textarea-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #0A0A0A inset !important;\n  -webkit-text-fill-color: #FFFFFF !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Footer wrapper for assistive text and character count */\n.scl--web-component-textarea-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.scl--web-component-textarea-assistive {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 4px 2px 14px;\n  height: 16px;\n  flex: 1;\n  order: 0;\n  flex-grow: 0;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: rgba(255, 255, 255, 0.54);\n}\n\n.scl--web-component-textarea-assistive.error {\n  color: #FF5252;\n}\n\n/* Character Count Styles */\n.scl--web-component-textarea-character-count {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 2px 14px 2px 4px;\n  height: 16px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: rgba(255, 255, 255, 0.54);\n  white-space: nowrap;\n}\n\n/* ✅ Floating Label Styles - Always visible, animates position */\n.scl--web-component-textarea-label {\n  position: absolute;\n  left: 21px;\n  top: 24px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 24px;\n  letter-spacing: 0.25px;\n  color: #7D8187;\n  background: transparent;\n  padding: 0 4px;\n  margin: 0 -4px;\n  pointer-events: none;\n  transition: all 0.3s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* ✅ Floating state - label moves to top */\n.scl--web-component-textarea-label.floating {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 14px;\n  line-height: 16px;\n  background: #0A0A0A;\n  color: #7D8187;\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n.scl--web-component-textarea-input-plate:focus-within .scl--web-component-textarea-label {\n  top: 0;\n  transform: translateY(-50%);\n  font-size: 14px;\n  line-height: 16px;\n  background: #0A0A0A;\n  color: #7D8187;\n  padding: 0 6px;\n  margin: 0 -6px;\n}\n\n/* ✅ Hover effect on label */\n.scl--web-component-textarea-input-plate:hover:not(:focus-within) .scl--web-component-textarea-label {\n  color: #C9CACD;\n}\n\n.scl--web-component-textarea-input-plate:hover:not(:focus-within) .scl--web-component-textarea-label .scl--web-component-textarea-required-asterisk {\n  color: #EB5252;\n}\n\n/* Clear Button Styles */\n.scl--web-component-textarea-clear-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  margin: 14px 0 0 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  color: #7D8187;\n  align-self: flex-start;\n  opacity: 1;\n  transform: scale(1);\n  transition: all 0.3s ease;\n  pointer-events: auto;\n}\n\n.scl--web-component-textarea-clear-button:hover {\n  color: #FFFFFF;\n}\n\n.scl--web-component-textarea-clear-button.hidden {\n  opacity: 0;\n  transform: scale(0.8);\n  pointer-events: none;\n}\n\n/* Required Asterisk Styles */\n.scl--web-component-textarea-required-asterisk {\n  color: #EB5252;\n}\n\n/* Custom scrollbar for textarea */\n.scl--web-component-textarea-input::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scl--web-component-textarea-input::-webkit-scrollbar-track {\n  background: rgba(125, 129, 135, 0.1);\n}\n\n.scl--web-component-textarea-input::-webkit-scrollbar-thumb {\n  background: #7D8187;\n  border-radius: 3px;\n}\n\n.scl--web-component-textarea-input::-webkit-scrollbar-thumb:hover {\n  background: #FFFFFF;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
